import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'urlLinks'
  })
  export class UrlLinkPipe implements PipeTransform {
    transform(text: any): any {
      const urlRegex = /(\b(https?|ftps?|file):\/\/[-A-Z\d+&@#\/%?=~_|!:,.;]*[-A-Z\d+&@#\/%=~_|])/ig;
  
      return text.replace(urlRegex, (url) => {
        return '<a href="' + url + '">' + url + '</a>';
      });
    }
  }